<p-panel [toggleable]="true" [collapsed]="shouldBeCollapsed">
  <ng-template #header
    ><div>
      <i class="fa-solid fa-car-battery mr-3"></i>EMS Info
    </div></ng-template
  >
  <p-table
    showGridlines="true"
    stripedRows
    size="small"
    [loading]="isLoading()"
    [value]="EMSList()"
  >
    <ng-template #header>
      <tr>
        <th class="lg:w-1/10 xl:w-1/12 2xl:w-1/14 3xl:w-1/16">
          <div class="text-center">
            <span class="hidden lg:inline">Status</span>
          </div>
        </th>
        <th>Type</th>
        <th>Last Update</th>
        <th>Read Only</th>
        <th>SoC</th>
        <th>Measured (W)</th>
        <th>Net (W)</th>
        <th>Override Mode</th>
        <th>Failure</th>
      </tr>
    </ng-template>
    <ng-template #body let-ems>
      <tr>
        <td
          [style]="
            iconsStyles.getDeviceStatusBackgroundStyle(
              customFunctions.getDeviceStatus(ems.available, ems.error)
            )
          "
        >
          <div class="text-center">
            <i
              [class]="
                iconsStyles.getDeviceStatusIcon(
                  customFunctions.getDeviceStatus(ems.available, ems.error)
                )
              "
              class="lg:mr-2"
            ></i
            ><span class="hidden lg:inline">{{
              customFunctions.getDeviceStatus(ems.available, ems.error)
            }}</span>
          </div>
        </td>
        <td>
          {{ ems.deviceType }}
        </td>
        <td>
          <span class="hidden lg:inline">
            {{ ems.lastUpdate | date : "yyyy-MM-dd, HH:mm" }} </span
          ><span class="lg:hidden">
            {{ ems.lastUpdate | date : "MM-dd, HH:mm" }}
          </span>
        </td>
        <td>
          <div class="text-center lg:text-left">
            <i
              class="lg:mr-2"
              [class]="iconsStyles.getLockIcon(ems.readOnly)"
              [style]="iconsStyles.getActiveStyle(!ems.readOnly)"
            ></i>
            <span class="hidden lg:inline">{{
              ems.readOnly ? "Yes" : "No"
            }}</span>
          </div>
        </td>
        <td>
          <i
            [class]="iconsStyles.getStateOfChargeIcon(ems.stateOfCharge)"
            class="mr-2"
          ></i
          >{{ ems.stateOfCharge }}%
        </td>
        <td>{{ ems.actualW }}</td>
        <td>{{ ems.netW }}</td>

        <td>@if(ems.overM === 0){-} @else {{{ems.overM}}}</td>
        <td>
          @if(ems.fault) {
          <i class="pi pi-exclamation-triangle" style="color: red"></i>} @else
          {-}
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-panel>
